// Le libellé du FANTÔME dans le bandeau, et la seule chose qui compte : qu'il TIENNE.
//
// Le bandeau est un flux qui pousse depuis la gauche (or, vies, chrono, dash, objet, son) tandis
// que le nom du niveau est collé à droite. Rien, dans un canvas, n'empêche deux textes de se
// superposer : le même défaut a déjà été vu le 22/07 sur l'indicateur de son, et le fantôme ajouté
// le 26/07 l'a reproduit — « 👻 boco 00:15.90 » écrit par-dessus « Premiers pas ».
//
// La règle : on réduit plutôt que de tronquer au milieu d'un mot ou d'écrire par-dessus. Le pseudo
// survit au chrono (savoir CONTRE QUI on court vaut mieux que le temps, qu'on lit déjà sur le
// coureur translucide), et l'emoji survit au pseudo (au moins on sait qu'un fantôme est en piste).
import { formatTime } from './format-time'

/**
 * `dispoPx` = la place réellement libre entre le curseur et le nom du niveau. `mesure` est injectée
 * (ctx.measureText en jeu) pour que la règle soit vérifiable sans canvas. Retourne '' quand même
 * l'emoji ne tient pas : mieux vaut ne rien écrire qu'écrire par-dessus.
 *
 * Mesuré avec la police du jeu (24px mono, bandeau de 1344 px) : sur « Premiers pas » il reste
 * 228 px et la forme complète en réclame 284. Le barreau intermédiaire — le chrono sans son
 * « 00: » de tête quand la course tient sous la minute — sert à récupérer le chrono partout où il
 * peut encore tenir, au lieu de le perdre dès le premier niveau un peu large.
 */
export function ghostHudLabel(
  pseudo: string, timeMs: number, dispoPx: number, mesure: (t: string) => number,
): string {
  const plein = formatTime(timeMs)
  const court = plein.startsWith('00:') ? plein.slice(3) : plein
  const essais = [`   👻 ${pseudo} ${plein}`, `   👻 ${pseudo} ${court}`, `   👻 ${pseudo}`, '   👻']
  for (const t of essais) if (mesure(t) <= dispoPx) return t
  return ''
}
